import React, { useState, useMemo, useEffect } from "react";
import ReactSelect from "../../../components/molecules/select/reactSelect";
import Image from "../../atom/image";
import Input from "../input/index";
import { getYearsDropdown, monthsDropdown } from "./config";
import styles from "./downloadFilter.module.css";
import { useRouter } from 'next/router';
// import { useLocation } from 'react-router-dom';

function DownloadFilter(props) {
  const router = useRouter();
  const year =
    props.selectedYear.value === "All" ? "" : props.selectedYear.value;

  const onViewChange = (e) => {
    if (!props.setLayoutView) return e;
    props.setLayoutView(e.target.value);
  };

  let tabsToModify = props.tabsToModify;

  return (
    <div className="row">
      <div className="col-md-10">
       
        <div className="row">
         { router.asPath !== "/download/monthly-communique" ? (<>
          <div className="col-md-4">
            <Input
              name="schameName"
              value={props.searchValue}
              onChange={props.onSearchChange}
              searchIcon={true}
              placeholder="Search"
              label="Search"
              margin={`nonBGtext + ${styles.margin}`}
              lblClass={styles.searchLabel}
              inputClass={styles.inputStyle}
            />
          </div>
         

           {(router.asPath !== "/download/leaflets-brochures" && router.asPath !== "/download/presentations") ? 
           (<>
            <div className={styles.filterItem}>
              <ReactSelect
                name="year"
                options={
                  props.yearsOptions ? props.yearsOptions : getYearsDropdown()
                }
                value={props.selectedYear}
                onChange={props.changeHandler}
                class="iconHide"
                label="Select Year"
                lblClass={styles.selectLabel}
                margin={styles.margin}
              />
            </div>
            <div className={styles.filterItem}>
              <ReactSelect
                name="month"
                options={monthsDropdown(year)}
                onChange={props.changeHandler}
                value={props.selectedMonth}
                class="iconHide"
                label="Select Month"
                lblClass={styles.selectLabel}
                margin={styles.margin}
              />
            </div> 
          </>): " "}

           </>) : ""}
        </div> 
      </div>
      <div className={`col-md-2 ${styles.layoutIcons}`} >
        {props.showLayoutView ? (
          <div>
            <div className="radio-tile-group">
              <div className="input-container">
                <input
                  id="walk"
                  className="radio-button"
                  value="list"
                  type="radio"
                  name="radio"
                  onChange={onViewChange}
                  checked={props.layoutView === "list" ? true : false}
                />
                <div className="radio-tile">
                  <div className="icon list-icon">
                    <Image image="/assets/images/category/list-icon.svg" />
                  </div>
                </div>
              </div>
              <div className="input-container">
                <input
                  id="bike"
                  className="radio-button"
                  value="grid"
                  type="radio"
                  name="radio"
                  onChange={onViewChange}
                  checked={props.layoutView === "grid" ? true : false}
                />
                <div className="radio-tile">
                  <div className="icon grid-icon">
                    <Image image="/assets/images/category/grid-icon.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

DownloadFilter.defaultProps = {
  showLayoutView: false,
  layoutView: "grid",
  setLayoutView: () => { },
};

export default DownloadFilter;
